import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { orderTrackingAnalyticsSchema } from "./schema/order-tracking-analytics";
import { createOrderTrackingOrderViewFolder } from "./schema/order-tracking-core/create-order-tracking-order-view-folder";
import { createOrderTrackingViewFolder } from "./schema/order-tracking-core/create-order-tracking-view-folder";
import { deleteOrderTrackingOrderView } from "./schema/order-tracking-core/delete-order-tracking-order-view";
import { deleteOrderTrackingOrderViewFolder } from "./schema/order-tracking-core/delete-order-tracking-order-view-folder";
import { deleteOrderTrackingView } from "./schema/order-tracking-core/delete-order-tracking-view";
import { deleteOrderTrackingViewFolder } from "./schema/order-tracking-core/delete-order-tracking-view-folder";
import { exportOrderTrackingShipments } from "./schema/order-tracking-core/export-order-tracking-shipments";
import { getOrderLookupSettings } from "./schema/order-tracking-core/get-order-lookup-settings";
import { getOrderTrackingOrderViewsAndFolders } from "./schema/order-tracking-core/get-order-tracking-order-views-and-folders";
import { getOrderTrackingShipmentDetail } from "./schema/order-tracking-core/get-order-tracking-shipment-detail";
import { getOrderTrackingShipments } from "./schema/order-tracking-core/get-order-tracking-shipments";
import { getOrderTrackingViewsAndFolders } from "./schema/order-tracking-core/get-order-tracking-views-and-folders";
import { getProvidersForTeam } from "./schema/order-tracking-core/get-providers-for-team";
import { getRecentOrders } from "./schema/order-tracking-core/get-recent-orders";
import { getTrackingPageGlobalSettings } from "./schema/order-tracking-core/get-tracking-page-global-settings";
import { getTrackingPageSettings } from "./schema/order-tracking-core/get-tracking-page-settings";
import { saveOrderTrackingOrderViewsAndFolders } from "./schema/order-tracking-core/save-order-tracking-order-views-and-folders";
import { saveOrderTrackingViewsAndFolders } from "./schema/order-tracking-core/save-order-tracking-views-and-folders";
import { updateOrderLookupSettings } from "./schema/order-tracking-core/update-order-lookup-settings";
import { updateOrderTrackingOrderViewFolder } from "./schema/order-tracking-core/update-order-tracking-order-view-folder";
import { updateOrderTrackingShipment } from "./schema/order-tracking-core/update-order-tracking-shipment";
import { updateOrderTrackingViewFolder } from "./schema/order-tracking-core/update-order-tracking-view-folder";
import { updateTrackingPageSettings } from "./schema/order-tracking-core/update-tracking-page-settings";
import { upsertOrderTrackingOrderView } from "./schema/order-tracking-core/upsert-order-tracking-order-view";
import { upsertOrderTrackingView } from "./schema/order-tracking-core/upsert-order-tracking-view";
import { upsertTrackingPageGlobalSettings } from "./schema/order-tracking-core/upsert-tracking-page-global-settings";
import { createTrackingPage } from "./schema/tracking-page-flow/create-tracking-page";
import { deleteTrackingPage } from "./schema/tracking-page-flow/delete-tracking-page";
import { getTrackingPageById } from "./schema/tracking-page-flow/get-tracking-page-by-id";
import { getTrackingPageFlowSteps } from "./schema/tracking-page-flow/get-tracking-page-flow-steps";
import { getTrackingPages } from "./schema/tracking-page-flow/get-tracking-pages";
import { setDefaultTrackingPage } from "./schema/tracking-page-flow/set-default-tracking-page";
import { updateTrackingPageById } from "./schema/tracking-page-flow/update-tracking-page-by-id";
import { updateTrackingPageFlow } from "./schema/tracking-page-flow/update-tracking-page-flow";

const orderTrackingSchema = {
  createOrderTrackingOrderViewFolder,
  createOrderTrackingViewFolder,
  deleteOrderTrackingOrderView,
  deleteOrderTrackingOrderViewFolder,
  deleteOrderTrackingView,
  deleteOrderTrackingViewFolder,
  exportOrderTrackingShipments,
  getOrderLookupSettings,
  getOrderTrackingOrderViewsAndFolders,
  getOrderTrackingShipmentDetail,
  getOrderTrackingShipments,
  getOrderTrackingViewsAndFolders,
  getProvidersForTeam,
  getRecentOrders,
  getTrackingPageGlobalSettings,
  getTrackingPageSettings,
  saveOrderTrackingOrderViewsAndFolders,
  saveOrderTrackingViewsAndFolders,
  updateOrderLookupSettings,
  updateOrderTrackingOrderViewFolder,
  updateOrderTrackingShipment,
  updateOrderTrackingViewFolder,
  updateTrackingPageSettings,
  upsertOrderTrackingOrderView,
  upsertOrderTrackingView,
  upsertTrackingPageGlobalSettings,
};

const trackingPageFlowSchema = {
  createTrackingPage,
  deleteTrackingPage,
  getTrackingPageById,
  getTrackingPageFlowSteps,
  getTrackingPages,
  setDefaultTrackingPage,
  updateTrackingPageById,
  updateTrackingPageFlow,
};

export const rpcDefinition = {
  ...orderTrackingSchema,
  ...trackingPageFlowSchema,
  ...orderTrackingAnalyticsSchema,
};

export type RedoOrderTrackingRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
